import TableFiltersContextProvider from "@/common/contexts/Table.context";
import { guardCheck } from "@/common/utils";
import { Loader } from "@/components";
import { lazy, Suspense } from "react";
import { redirect } from "react-router";

const AIRXServicePage = lazy(() => import("@/pages/AIRXPages/Services.page"));
const ServicesById = lazy(() => import("@/pages/AIRXPages/ServicesById.page"));
const ServicesMePage = lazy(
  () => import("@/pages/CustomerPages/ServicesMe.page")
);
const ServiceByIdMe = lazy(
  () => import("@/pages/CustomerPages/ServiceByIdMe.page")
);
const VendorServices = lazy(
  () => import("@/pages/VendorsPages/VendorServices.page")
);
const VendorServiceById = lazy(
  () => import("@/pages/VendorsPages/VendorServicesById.page")
);
const servicesRoute = [
  {
    path: "services",
    loader: async ({ request }: { request: Request }) => {
      const isAllowed = guardCheck(request, "services/airx");
      if (!isAllowed) {
        throw redirect("/404");
      }
      return request;
    },
    element: (
      <Suspense fallback={<Loader />}>
        <TableFiltersContextProvider>
          <AIRXServicePage />
        </TableFiltersContextProvider>
      </Suspense>
    ),
  },
  {
    path: "services/:servicesId",
    loader: async ({ request }: { request: Request }) => {
      const isAllowed = guardCheck(request, "services/airx");
      if (!isAllowed) {
        throw redirect("/404");
      }
      return request;
    },
    element: (
      <Suspense fallback={<Loader />}>
        <ServicesById />
      </Suspense>
    ),
  },
  {
    path: "services/customer/me",
    loader: async ({ request }: { request: Request }) => {
      const isAllowed = guardCheck(request, "services/customer/vendor");
      if (!isAllowed) {
        throw redirect("/404");
      }
      return request;
    },
    element: (
      <Suspense>
        <TableFiltersContextProvider>
          <ServicesMePage />
        </TableFiltersContextProvider>
      </Suspense>
    ),
  },
  {
    path: "services/customer/me/:servicesId",
    loader: async ({ request }: { request: Request }) => {
      const isAllowed = guardCheck(request, "services/customer/vendor");
      if (!isAllowed) {
        throw redirect("/404");
      }
      return request;
    },
    element: (
      <Suspense fallback={<Loader />}>
        <ServiceByIdMe />
      </Suspense>
    ),
  },
  {
    path: "services/vendor/me",
    loader: async ({ request }: { request: Request }) => {
      const isAllowed = guardCheck(request, "services/customer/vendor");
      if (!isAllowed) {
        throw redirect("/404");
      }
      return request;
    },
    element: (
      <Suspense fallback={<Loader />}>
        <TableFiltersContextProvider>
          <VendorServices />
        </TableFiltersContextProvider>
      </Suspense>
    ),
  },
  {
    path: "services/vendor/me/:servicesId",
    loader: async ({ request }: { request: Request }) => {
      const isAllowed = guardCheck(request, "services/customer/vendor");
      if (!isAllowed) {
        throw redirect("/404");
      }
      return request;
    },
    element: (
      <Suspense fallback={<Loader />}>
        <VendorServiceById />
      </Suspense>
    ),
  },
];
export default servicesRoute;
